"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValueLabel = exports.getItemNameKeys = exports.getTagValues = exports.getTagValue = exports.getItemName = exports.getCleanPrimitiveStringValue = exports.TAG_TYPES = exports.getDefaultItemForTypeStructure = exports.getTypeStructureIsPrimitive = exports.getTypeStructureByPath = exports.getCleanTypeStructureMap = exports.getCleanTypeStructure = exports.getMergedTypeStructure = exports.getTypeStructureByName = exports.getTypeStructureWithFilteredContent = exports.getCleanType = exports.combineTypeStructures = exports.identifyValueType = void 0;
const NOOP = () => undefined;
const identifyValueType = (value, typeStructureVariety = []) => {
    var _a;
    const typeStructureMap = typeStructureVariety.reduce((acc, typeStructure) => {
        acc[typeStructure.type] = typeStructure;
        return acc;
    }, {});
    const valueTypeSignature = value && typeof value === "object"
        ? Object.keys(value).sort()
        : typeof value;
    const scoreMap = {};
    for (const tS of typeStructureVariety) {
        if (typeof valueTypeSignature === "string" &&
            tS.type === valueTypeSignature) {
            return tS;
        }
        else if (valueTypeSignature instanceof Array) {
            const typeSignature = ((_a = tS.content) === null || _a === void 0 ? void 0 : _a.length)
                ? tS.content.map((tSC) => tSC.name).sort()
                : tS.type;
            if (typeSignature instanceof Array) {
                for (const typeSigProp of typeSignature) {
                    if (valueTypeSignature.includes(typeSigProp)) {
                        scoreMap[tS.type] = scoreMap[tS.type] ? scoreMap[tS.type] + 1 : 1;
                    }
                    else {
                        scoreMap[tS.type] = scoreMap[tS.type] ? scoreMap[tS.type] : 0;
                    }
                }
            }
        }
    }
    const typeList = Object.keys(scoreMap);
    return typeList.reduce((acc, typeName) => {
        if (!acc || scoreMap[typeName] > (scoreMap[acc.type] || 0)) {
            return typeStructureMap[typeName];
        }
        else {
            return acc;
        }
    }, typeStructureVariety[0]);
};
exports.identifyValueType = identifyValueType;
const combineTypeStructures = (name, type, typeStructures = []) => {
    let combinedTypeStructure;
    for (const tS of typeStructures) {
        combinedTypeStructure = combinedTypeStructure
            ? Object.assign(Object.assign(Object.assign({}, combinedTypeStructure), tS), { content: [
                    ...(combinedTypeStructure.content || []),
                    ...(tS.content || []),
                ] }) : tS;
    }
    return combinedTypeStructure
        ? Object.assign(Object.assign({}, combinedTypeStructure), { name,
            type }) : undefined;
};
exports.combineTypeStructures = combineTypeStructures;
const getCleanType = (typeValue = "", namespace) => {
    const cleanType = typeValue.replace(/\[]/gim, () => "");
    return namespace ? `${namespace}.${cleanType}` : cleanType;
};
exports.getCleanType = getCleanType;
const getTypeStructureWithFilteredContent = ({ allowed = [], disallowed = [] } = {}, typeStructure) => {
    const { content = [] } = typeStructure;
    const newContent = allowed && allowed.length > 0
        ? content.filter((tS) => allowed.includes(tS.name))
        : disallowed && disallowed.length > 0
            ? content.filter((tS) => !disallowed.includes(tS.name))
            : content;
    return Object.assign(Object.assign({}, typeStructure), { content: newContent });
};
exports.getTypeStructureWithFilteredContent = getTypeStructureWithFilteredContent;
const getTypeStructureByName = (name, map) => map[name];
exports.getTypeStructureByName = getTypeStructureByName;
const getMergedTypeStructure = (...typeStructures) => {
    let mergedTypeStructure = undefined;
    for (const tS of typeStructures) {
        const partialMergedTS = mergedTypeStructure || {};
        const partialTS = tS || {};
        const { tags: mergedTags = {} } = partialMergedTS;
        const { tags: tSTags = {} } = partialTS;
        mergedTypeStructure = Object.assign(Object.assign(Object.assign({}, partialMergedTS), tS), { tags: Object.assign(Object.assign({}, mergedTags), tSTags) });
    }
    return mergedTypeStructure;
};
exports.getMergedTypeStructure = getMergedTypeStructure;
const getCleanTypeStructure = (typeStructure, typeStructureMap) => {
    const { namespace, name, type, typeAlias, literal, comments = [], tags = {}, } = typeStructure;
    if (literal) {
        return typeStructure;
    }
    else {
        const cleanType = (0, exports.getCleanType)(type);
        const cleanTypeWithNamespace = (0, exports.getCleanType)(type, namespace);
        const { [cleanTypeWithNamespace]: mappedTypeStructureWithNamespace, [cleanType]: mappedTypeStructureNoNamespace, } = typeStructureMap || {};
        const useMappedWithNamespace = !!mappedTypeStructureWithNamespace;
        const mappedTypeStructure = useMappedWithNamespace
            ? mappedTypeStructureWithNamespace
            : mappedTypeStructureNoNamespace;
        const { comments: mappedTypeStructureComments = [], tags: mappedTypeStructureTags = {}, } = mappedTypeStructure || {};
        const mergedTypeStructure = Object.assign(Object.assign(Object.assign({}, mappedTypeStructure), typeStructure), { name, typeAlias: mappedTypeStructure ? type : typeAlias, comments: [...mappedTypeStructureComments, ...comments], tags: Object.assign(Object.assign({}, mappedTypeStructureTags), tags) });
        const typeForMatching = useMappedWithNamespace
            ? cleanTypeWithNamespace
            : cleanType;
        const cleanMappedType = (0, exports.getCleanType)((mappedTypeStructure === null || mappedTypeStructure === void 0 ? void 0 : mappedTypeStructure.type) || "", mappedTypeStructure === null || mappedTypeStructure === void 0 ? void 0 : mappedTypeStructure.namespace);
        if (mappedTypeStructure && cleanMappedType !== typeForMatching) {
            return (0, exports.getCleanTypeStructure)(mergedTypeStructure, typeStructureMap);
        }
        return mergedTypeStructure;
    }
};
exports.getCleanTypeStructure = getCleanTypeStructure;
const getCleanTypeStructureMap = (typeStructureMap) => {
    const cleanTypeStructureMap = {};
    for (const [key, typeStructure] of Object.entries(typeStructureMap)) {
        cleanTypeStructureMap[key] = (0, exports.getCleanTypeStructure)(typeStructure, typeStructureMap);
    }
    return cleanTypeStructureMap;
};
exports.getCleanTypeStructureMap = getCleanTypeStructureMap;
const getTypeStructureByPath = (path, typeStructure, typeStructureMap) => {
    const { multiple = false, type = "" } = typeStructure;
    const baseTS = (0, exports.getCleanTypeStructure)(typeStructure, typeStructureMap);
    const { content = [] } = baseTS || {};
    const [firstPathPart, ...multiPath] = path;
    const firstPathPartIsNumber = !isNaN(Number(firstPathPart));
    const firstPathPartIsInContent = !!content.find(({ name }) => name === firstPathPart);
    const isItemSubPath = firstPathPartIsNumber || !firstPathPartIsInContent;
    const targetPath = multiple && isItemSubPath ? multiPath : path;
    let tS = baseTS;
    if (tS && targetPath.length > 0) {
        const [targetPathPart, ...remainingPath] = targetPath;
        const { content: currentContentList = [] } = tS;
        const targetContent = currentContentList.find(({ name }) => name === targetPathPart);
        if (targetContent) {
            tS = (0, exports.getTypeStructureByPath)(remainingPath, targetContent, typeStructureMap);
        }
    }
    return tS ? tS : {};
};
exports.getTypeStructureByPath = getTypeStructureByPath;
const getTypeStructureIsPrimitive = (typeStructure) => {
    const { literal = false, content = [] } = typeStructure;
    return literal && content.length === 0;
};
exports.getTypeStructureIsPrimitive = getTypeStructureIsPrimitive;
const getDefaultItemForTypeStructure = (typeStructure) => {
    const { type, multiple } = typeStructure;
    const isPrimitive = (0, exports.getTypeStructureIsPrimitive)(typeStructure);
    if (isPrimitive) {
        switch (type) {
            case "string":
                return "";
            case "number":
                return 0;
            case "boolean":
                return false;
            default:
                return undefined;
        }
    }
    else {
        return multiple ? [] : {};
    }
};
exports.getDefaultItemForTypeStructure = getDefaultItemForTypeStructure;
var TAG_TYPES;
(function (TAG_TYPES) {
    TAG_TYPES["label"] = "label";
    TAG_TYPES["inline"] = "inline";
    TAG_TYPES["layout"] = "layout";
    TAG_TYPES["displayLayout"] = "displayLayout";
    TAG_TYPES["itemName"] = "itemName";
    TAG_TYPES["options"] = "options";
    TAG_TYPES["optionsType"] = "optionsType";
    TAG_TYPES["allowCustomValue"] = "allowCustomValue";
})(TAG_TYPES || (exports.TAG_TYPES = TAG_TYPES = {}));
const getCleanPrimitiveStringValue = (value) => value !== undefined && value !== null ? `${value}` : "";
exports.getCleanPrimitiveStringValue = getCleanPrimitiveStringValue;
const getItemName = (item = {}, itemNameTemplate = "") => itemNameTemplate.replace(/\`(\w+)\`/g, (match, key) => (0, exports.getCleanPrimitiveStringValue)(item[key]));
exports.getItemName = getItemName;
const getTagValue = (tagName, typeStructure) => {
    const { tags: { [tagName]: { value: tagValue = undefined } = {} } = {} } = typeStructure;
    return tagValue;
};
exports.getTagValue = getTagValue;
const getTagValues = (tagNames = [], typeStructure) => {
    const tagValues = {};
    for (const tagName of tagNames) {
        tagValues[tagName] = (0, exports.getTagValue)(tagName, typeStructure);
    }
    return tagValues;
};
exports.getTagValues = getTagValues;
const getItemNameKeys = (itemNameTemplate = "") => { var _a; return (_a = itemNameTemplate.match(/\`(\w+)\`/g)) !== null && _a !== void 0 ? _a : []; };
exports.getItemNameKeys = getItemNameKeys;
const getValueLabel = (value, typeStructure, typeStructureMap) => {
    const itemNameTemplate = (0, exports.getTagValue)(TAG_TYPES.itemName, typeStructure);
    if (typeof itemNameTemplate === "string" && itemNameTemplate.trim() !== "") {
        const itemNameKeys = (0, exports.getItemNameKeys)(itemNameTemplate);
        const templateValueItem = {};
        for (const itemNameKey of itemNameKeys) {
            const key = itemNameKey.replace(/\`/g, "");
            const typeStructureItem = (0, exports.getTypeStructureByPath)([key], typeStructure, typeStructureMap);
            templateValueItem[key] = (0, exports.getValueLabel)(value === null || value === void 0 ? void 0 : value[key], typeStructureItem, typeStructureMap);
        }
        return (0, exports.getItemName)(templateValueItem, itemNameTemplate);
    }
    else {
        return value === undefined || value === null ? "" : `${value}`;
    }
};
exports.getValueLabel = getValueLabel;
